import { Component, type ReactNode } from 'react';
import { t } from '../i18n';

/** A rendering bug on one screen must not blank the whole app on a driver's phone. */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey?: string }, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidUpdate(prev: { resetKey?: string }) {
    if (prev.resetKey !== this.props.resetKey && this.state.failed) this.setState({ failed: false });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="card my-4">
        <p className="text-bad">{t('err.generic')}</p>
        <button type="button" className="btn mt-3 w-full" onClick={() => window.location.reload()}>
          {t('common.retry')}
        </button>
      </div>
    );
  }
}
